import { drawImage } from './drawImage';
import type { CanvasRenderingContext } from './types';

const clipCircle = (x: number, y: number, r: number) => {
  const clip = new Path2D();
  clip.ellipse(x, y, r, r, 0, 0, 2 * Math.PI);
  return clip;
};

/** @param imageSize the dimension of the square region in which to  */
const paintImageInCircle = (
  context: CanvasRenderingContext,
  href: string,
  cx: number,
  cy: number,
  clipRadius: number,
  imageSize = 2 * clipRadius
) => {
  context.save();
  context.clip(clipCircle(cx, cy, clipRadius));
  drawImage(context, href, cx, cy, imageSize);
  context.restore();
};
export { paintImageInCircle };
